"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var index_1 = require("../index");
var lines_1 = tslib_1.__importDefault(require("./lines"));
var validation_1 = require("../../../util/resources/validation");
var JournalEntryResource = /** @class */ (function (_super) {
    tslib_1.__extends(JournalEntryResource, _super);
    function JournalEntryResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    JournalEntryResource.related = function () {
        return Object.assign({}, index_1.BaseTransactionResource.related(), {
            lines: lines_1.default,
        });
    };
    JournalEntryResource.endpoint = '/jes';
    JournalEntryResource.MODEL_NAME = 'journalentry';
    JournalEntryResource.defaults = Object.assign({}, index_1.BaseTransactionResource.defaults, {
        lines: [],
        debits_decimal: '0.00',
        credits_decimal: '0.00',
    });
    JournalEntryResource.validation = validation_1.extendValidators(index_1.BaseTransactionResource, {
        debits_decimal: [validation_1.isValidCurrency('debits_decimal'), validation_1.jeDebitsEqualCredits()],
        credits_decimal: [validation_1.isValidCurrency('credits_decimal')],
    });
    return JournalEntryResource;
}(index_1.BaseTransactionResource));
exports.default = JournalEntryResource;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/je/index.js
// module id = 0kHF
// module chunks = 0